import { SimpleElectricityAgreement } from "./agreement";

export interface MeteringPoint {
    id: number;
    eic: string;
    address: string;
    checked?: boolean;
    earliestPossibleAgreementStartDate: string;
    productionCapacity: number;
    offerProductionCapacity: number;
    relatedAgreement?: SimpleElectricityAgreement;
    hasMatchingGridOperator: boolean;
    terminationFee: boolean;
}

export interface CustomerMeteringPoints {
    customerEic: string;
    meteringPoints: MeteringPoint[];
}

export interface MeteringPointMeasurements {
    startDate: string;
    endDate: string;
    resolution: MeteringPointMeasurementResolution;
    statistics: {
        currentMonthConsumptionKwh: number;
        currentMonthProductionKwh: number;
        lastMonthConsumptionAtTimeOfRequestKwh: number;
        lastMonthProductionAtTimeOfRequestKwh: number;
        lastYearConsumptionAtTimeOfRequestKwh: number;
        lastYearProductionAtTimeOfRequestKwh: number;
        lastMonthConsumptionTotalKwh: number;
        lastMonthProductionTotalKwh: number;
        consumptionForPeriodKwh: number;
        productionForPeriodKwh: number;
        lastYearConsumptionForPeriodKwh: number;
        lastYearProductionForPeriodKwh: number;
    };
    measurements: MeteringPointMeasurementsDataPoint[];
}

export interface MeteringPointMeasurementsDataPoint {
    time: string;
    consumptionKwh: number;
    productionKwh: number;
}

export enum MeteringPointMeasurementResolution {
    HOUR = 'HOUR',
    DAY = 'DAY',
    MONTH = 'MONTH'
}
